import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import Form from './components/Form';
import RaisedButton from 'material-ui/RaisedButton';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {priceTag} from 'react-icons-kit/icomoon/priceTag';

import ModalReserved from '../aliquots/components/modalReserved';

var Config = require('../../../config');

class ModifyComponent extends Component{
	constructor(props){
		super(props);
		
		this.onSave = this.onSave.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.clearValues = this.clearValues.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.hideBtn = this.hideBtn.bind(this);
		this.disableLabelBtn = this.disableLabelBtn.bind(this);
		this.getReserved = this.getReserved.bind(this);
		this.saving = this.saving.bind(this);

		this.state = {
			criterials:{},		
			preview_print:{},
			new_id:"",
			btn_new:false,
			no_print:false
		}
	}

	componentDidMount(){
		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		});
	}	

	getReserved(result){
		var parts = {
			process: this.form.getProcessData(),
			reserved_units: result
		};

		this.saving(parts);
	}

	onSave(){
		if (this.isValidDate(this.form.state.date)){
			
			if(this.isValidForm()){
				var parts = {
					process: this.form.getProcessData()
				};

				var error_date = parts.process.transformation_parts.findIndex(obj =>
					obj.error_date === true
				);

				if(this.form.state.reserved_list.length === 0){
					if(parts.process.transformation_parts.length === 0){
						swal('¡Error!', "No ha seleccionado ninguna unidad", 'error');
					}else if(parts.process.hour === "Invalid date"){
						notify.show("Error, Hora invalida", 'error');
					}else if(parts.process.status !== ""){
						swal(
							'Error', 
							'No se puede aplicar el proceso a las unidades '+
							parts.process.status+
							' debido a que se encuentran bloqueadas.', 
							'error'
						);
					}else if(error_date !== -1){
						swal('Error', 'LOS DÍAS MÁXIMOS DE CADUCIDAD PARA PROCESO DE ILUMINADO SON '+this.form.state.dias, 'error');
					}else{
					
						this.saving(parts);
					}
				}else{
					this.modal_reserved.handleShow(this.form.state.reserved_list);
				}

				
			}else {
		    	swal('¡Error!', "Campos incompletos", 'error');
	        }
        }else {
			notify.show('Error, Fecha no válida','error');	    	
        }	
	}

	saving(data){
		this.waiting_modal.handleShow('Guardando...');
		fetch(Config.default.apiGateway.URL+'transformation_process', {
			method : 'post',
			body: JSON.stringify(data),
			headers : new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
			return res.json();
			}else{
				res.text().then(function(result) {
					swal('¡Error', result, 'error');
				});
			}})
		.then(response => {
			if(response !== undefined){
				swal('¡Buen Trabajo!', "Proceso Terminado", 'success');

				this.setState({new_id:response.id, btn_new:true});
				//this.onPrint(response.id);
			}
		})
	}

	onPrint(){
		this.props.waiting.handleShow('Imprimiendo...');
          
		var units = [this.state.new_id];

		fetch(Config.default.apiGateway.URL+'labelsEditor/print_bag_labels?health_facilities_id='+
			sessionStorage.getItem('health_facilities_id'), {
			method : 'post',
			body:JSON.stringify(units),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					return;
				});
			}
		}).then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value === "NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = ()=>{
						var base64data = reader.result;  
						var aux = base64data.split(',');
						this.props.socket.send('{"Operacion":"print", "Type":"label_bags", "File": "'+aux[1]+'"}');
					}
				}

			}
		});
	}

	isValidDate(fecha){

		var aux_fecha = moment(fecha.split('-').reverse().join('/'), 'DD-MM-YYYY');

		var valid_fecha = aux_fecha.format('MM-DD-YYYY');

		if(valid_fecha === 'Invalid date')
			return false;
		
		return true;
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.form.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}		   
		  	}
	    });
	    
	    return isFormValid;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 2].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	onReturn(){
		this.props.history.push('/modify_component');
	}

	clearValues(){
		if(this.form.state.option !== 'Unit'){
			//Limpiar componente seleccionado
			this.form.criterials.setState({blood_component_id:""});
			//Recargar componentes
			this.form.criterials.getBloodComponent('blood_component/has_unit');
		}else{
			this.form.unit.setState({
				unit_number   : "",
				unit_required : false,
				code_component: "",
				code_required : false,
				results:[],
				components:[]
			})
		}

		this.form.setState({
			component_id: "",
			final_component_id:"",
			final_component:[],
			process_id:"",
			equipment_id:"",
			modify:[]
		})

		this.hideBtn();
	}

	hideBtn(){
		this.setState({btn_new:false});
	}

	disableLabelBtn(){
		this.setState({no_print: true});
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.modify_component.MAIN')}
					</h5>
				</div>
				<form noValidate>						
					<Form {...this.props}  validate={this.validateInput} 
						clear={this.hideBtn} state={this.state} 
						disableBtn={this.disableLabelBtn}
						onRef={ref => (this.form = ref)} />
					<Notifications />
				</form>

				<div className="col-xs-12 form-group" style={{marginTop:'10px', textAlign:'center'}}>
					<button className="toolIcon" onClick={this.onPrint}
						disabled={this.state.new_id.length === 0 ? true : this.state.no_print}>
						<SvgIcon size={40} icon={priceTag} />
						<div className="col-xs-12">
							<span>Etiqueta</span>
						</div>
					</button>
				</div>

				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
		        		{this.state.btn_new ? 
		        			<RaisedButton className="action-btn" label={'Nuevo'} primary={true} onClick={this.clearValues}  style={{margin:12}}/>
		        		: <RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>}
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onReturn} style={{margin:12}}/>
		        	</div>
		        </div>
				<ModalReserved {...this.props} onRef={ref => this.modal_reserved = ref} getReserved={this.getReserved} />
		        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations') (ModifyComponent);